

export enum PaymentProviderType {
  Mangopay = 'mangopay',
  Stripe = 'stripe',
}

export const activatedPaymentProvider = [
  PaymentProviderType.Mangopay,
];

export class UserPaymentProvider {
  public id!: number;

  public providerGeneralConditions: Date;
  public providerId: string;
  public providerType: PaymentProviderType;
  public userInfoId: number;

  public readonly createdAt!: Date;
  public readonly updatedAt!: Date;

  constructor(data: Partial<UserPaymentProvider>) {
    Object.assign(this, data);
  }

}
